import React from 'react';
import { Button, EmptyContent } from '@/components/ui';
import ErrorLayout from '@/components/ErrorLayout';
import { IconServerOff } from '@tabler/icons-react';

export const ServerErrorPage: React.FC = () => {
  return (
    <ErrorLayout>
      <EmptyContent
        state="error"
        title="Server Error"
        description="Something went wrong on our end. Please try again later."
        icon={<IconServerOff />}
        withIconBox
      >
        <Button
          onClick={() => window.location.reload()}
          variant="classic"
          color="secondary"
        >
          Refresh Page
        </Button>
      </EmptyContent>
    </ErrorLayout>
  );
};
